import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToTop = props => /*#__PURE__*/_jsxs("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: [/*#__PURE__*/_jsx("circle", {
    fill: "#F8F8F8",
    cx: 6,
    cy: 6,
    r: 10,
    transform: "translate(6 6)"
  }), /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M12 11.111L9.611 13.5a.537.537 0 01-.778 0 .537.537 0 010-.778L12 9.556l3.167 3.166a.537.537 0 010 .778.537.537 0 01-.778 0L12 11.11z"
  })]
});
export default SvgToTop;